<template>
  <div>
    <div v-if="isValid" class="wrapper">
      <GlobalEvents
        @keyup.arrow-up="prevResult"
        @keyup.arrow-down="nextResult"
        @keypress.enter="applyCurrentResult"
        @keydown.esc="clear"
      />
      <SearchInput
        v-on:change-keyword="keyword = $event"
        v-on:complete-search="updateIsNotFound"
      />
      <AutoCompleteList
        :search-result-list="searchResultList"
        :current-search-result-index="currentSearchResultIndex"
        :keyword="keyword"
        :is-not-found="isNotFound"
      />
    </div>
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events'
import SearchInput from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/serach/SearchInput'
import AutoCompleteList from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/serach/AutoCompleteList'
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'
import RouteHelper from '@/mixins/RouteHelper'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Search',
  components: {
    GlobalEvents,
    SearchInput,
    AutoCompleteList,
  },
  mixins: [RouteHelper],
  data: () => ({
    autoCompleteResult: [],
    currentResult: null,
    isNotFound: false,
  }),
  computed: {
    ...mapGetters('pointGroupOperation', ['searchQuery']),
    keyword: {
      get() {
        return this.searchQuery
      },
      set(value) {
        this.updateSearchQuery(value)
      },
    },
    isValid() {
      if (this.underSystemOwnerPage) return false

      const pagePermission = this.$store.getters[getters.pagePermission]
      const targetGroup = this.$store.getters[getters.targetGroup]
      return pagePermission === 'edit' && targetGroup.id
    },
    targetGroup() {
      return this.$store.getters[getters.targetGroup]
    },
    searchResultList() {
      return this.$store.getters[getters.searchResultList]
    },
    currentSearchResultIndex() {
      return this.$store.getters[getters.currentSearchResultIndex]
    },
  },
  methods: {
    ...mapActions('pointGroupOperation', {
      updateSearchQuery: 'UPDATE_SEARCH_QUERY',
    }),
    clear() {
      this.$store.dispatch(actions.CLEAR_SEARCH)
    },
    prevResult() {
      try {
        this.$store.dispatch(actions.FOCUS_PREV_SEARCH_RESULST)
      } catch (e) {
        // 前に結果が無い場合
        this.$refs.input.focusInput()
      }
    },
    nextResult() {
      this.$store.dispatch(actions.FOCUS_NEXT_SEARCH_RESULST)
    },
    applyCurrentResult() {
      this.$store.dispatch(actions.APPLY_FOCUSED_SEARCH_RESULT)
    },
    updateIsNotFound() {
      const queryIsDefined = this.keyword !== ''
      const resultIsEmpty = this.searchResultList.length === 0

      this.isNotFound = queryIsDefined && resultIsEmpty
    },
  },
  watch: {
    targetGroup() {
      this.clear()
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  position: absolute;
  top: 10px;
  right: 50px;
  background: white;
  width: 400px;
  z-index: 2;
}
</style>
